import React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header'
import { StaticQuery, graphql } from 'gatsby'
import './index.css'
import '../stylesheet/main.scss'

export default ({ children }) => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <div>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            {
              name: 'description',
              content:
                'Kenneth Au is a software engineer with commercial experiences in building application in React, React Native as well as years of experience in Shopify and Wordpress',
            },
            {
              name: 'keywords',
              content:
                'React Developer Brisbane, Shopify Developer Brisbane, Wordpress, Software Engineer, Kenneth Au, React Native and Redux, AWS Lambda, Node JS',
            },
            {
              name: 'google-site-verification',
              content: 'UA6mF_R1SXPLVUSSakxODp51gzgjzxWa5tnbMjfXLBM',
            },
          ]}
        />
        <Header siteTitle={data.site.siteMetadata.title} />
        {children}
      </div>
    )}
  />
)
